import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { coPiAlertState } from "../../store/CopilotListState";

const CopilotObserver = (prop) => {

  const {contents} = prop;

  // Alert
  const alerts = useRecoilValue(coPiAlertState);
  useEffect(() => {
    contents.setAlerts(alerts);
  }, [alerts, contents]);

    return null;
  }

export default CopilotObserver;
